export const dataConfig = {
    "strokeColor": {
        "yellow": "#F57F17",
        "red": "#f44336",
        "orange": "#FF9800",
        "deepOrange": "#FF5722",
        "gray": "#757575",
        "pink": "#EC407A",
        "blue": "#2196F3",
        "green": "#4CAF50",
        "brown": "#795548",
        "purple": "#9C27B0",
        "deepGreen": "#009688",
        "white": "#fff",
        "redOrange": "#ee3840",
        "blueLight": "#38cdee",
        "greenCyan": "#008F8C"
    },
    "fillColor": {
        "yellow": "rgba(255,235,59,0.3)",
        "red": "rgba(244,67,54,0.3)",
        "orange": "rgba(255,152,0,0.3)",
        "deepOrange": "rgba(255,87,34,0.3)",
        "gray": "rgba(117,117,117,0.3)",
        "pink": "rgba(236,64,122,0.3)",
        "blue": "rgba(33,150,243,0.3)",
        "green": "rgba(76,175,80,0.3)",
        "purple": "rgba(156,39,176,0.3)",
        "deepGreen": "rgba(0,150,136,0.3)",
        "white": "transparent"
    },
    "mapping": {
        "BHK": "yellow",
        "BHK+CLN": "yellow",
        "BHK+LUC": "yellow",
        "BHK+LUK": "yellow",
        "CAN": "red",
        "CLN": "orange",
        "CLN+BHK": "orange",
        "CLN+BHK+LUK": "orange",
        "CLN+LUK": "orange",
        "CLN+NTS": "orange",
        "CLN+SKC": "orange",
        "COC": "yellow",
        "CQP": "red",
        "DBV": "deepOrange",
        "DCH": "deepOrange",
        "DCS": "deepOrange",
        "DGD": "purple",
        "DGT": "orange",
        "DHT": "green",
        "DDL": "orange",
        "DKV": "deepOrange",
        "DNL": "deepOrange",
        "DLL": "deepOrange",
        "DRA": "deepOrange",
        "DSH": "deepOrange",
        "DTL": "blue",
        "DTS": "deepOrange",
        "DTT": "deepOrange",
        "DVH": "deepOrange",
        "DXH": "deepOrange",
        "DYT": "deepOrange",
        "HNK": "yellow",
        "KDT": "deepGreen",
        "LUC": "yellow",
        "LUC+BHK": "yellow",
        "LUK": "yellow",
        "LUK+BHK": "yellow",
        "LUK+CLN": "yellow",
        "LUK+NTS": "yellow",
        "LUN": "yellow",
        "MNC": "blue",
        "NHK": "yellow",
        "NKH": "yellow",
        "NTD": "gray",
        "NTS": "blue",
        "ODT": "pink",
        "ODT+BHK": "pink",
        "ODT+CLN": "pink",
        "ODT+HNK": "pink",
        "ONT": "pink",
        "ONT+BHK": "pink",
        "ONT+BHK+CLN": "pink",
        "ONT+BHK+LUK": "pink",
        "ONT+BHK+SKC": "pink",
        "ONT+CLN": "pink",
        "ONT+CLN+BHK": "pink",
        "ONT+CLN+LUK": "pink",
        "ONT+CLN+NTS": "pink",
        "ONT+LUC": "pink",
        "ONT+LUK": "pink",
        "ONT+NTS": "pink",
        "ONT+SKC": "pink",
        "PNK": "blue",
        "RDD": "green",
        "RDM": "green",
        "RPH": "green",
        "RSX": "green",
        "SKC": "purple",
        "SKC+BHK": "deepOrange",
        "SKC+CLN": "deepOrange",
        "SKN": "deepOrange",
        "SKS": "deepOrange",
        "SKX": "deepOrange",
        "SON": "blue",
        "TMD": "deepOrange",
        "TON": "deepOrange",
        "TSC": "red",
        "QMDTB": "deepOrange",
        "QMDTH": "yellow",
        "HMDTH": "green",
        "HMDTB": "deepGreen",
        "CAO": "deepOrange",
        "TBI": "orange",
        "THP": "pink",
        "CAU": "blue",
        "TIM": "green",
        "D10": "yellow",
        "VIAHE": "white",
        "DNH": "green",
        "DNGH": "pink",
        "DNGQ": "orange",
        "DNGDQ": "red",
        "TBAH": "deepGreen",
        "TBAQ": "deepOrange",
        "CTNH": "blue",
        "CTNQ": "blue",
        "CXAH": "deepGreen",
        "GIKT": "purple",
        "LVCH": "deepOrange",
        "COPH": "green",
        "ANTEN": "green",
        "TUCACH": "deepOrange",
        "VNPT": "blue",
        "MOBIFONE": "red",
        "VIETTEL": "greenCyan",
        "GTEL": "yellow",
        "VIETNAMOBILE": "orange",
        "DOH": "blueLight",
        "DOQ": "purple",
        "HCHH": "red",
        "HVH": "yellow"
    },
    "weightLine": {
        "CHI": 5,
        "CAU": 5,
        "TIM": 5,
        "VIAHE": 1,
        "TBAH": 1,
        "TBAQ": 1
    },
    "icon": {
        "VNPT": "http://ilis.tayninh.gov.vn/quyhoach/icon/VNPT.png",
        "MOBIFONE": "http://ilis.tayninh.gov.vn/quyhoach/icon/MOBIFONE.png",
        "VIETTEL": "http://ilis.tayninh.gov.vn/quyhoach/icon/VIETTEL.png",
        "GTEL": "http://ilis.tayninh.gov.vn/quyhoach/icon/GTEL.png",
        "VIETNAMOBILE": "http://ilis.tayninh.gov.vn/quyhoach/icon/VIETNAMOBILE.png"
    }
}
